import { blockBody, unblockBody } from "../../body";

const menu = document.querySelector(".menu");
const button = document.querySelector(".menu-button");
const overlay = menu.querySelector(".menu__overlay");
let opened = false;

function openMenu() {
  opened = true;
  menu.classList.add("menu_opened");
  button.classList.add("menu-button_opened");
  blockBody();
}

function closeMenu() {
  console.log(opened);
  opened = false;
  menu.classList.remove("menu_opened");
  button.classList.remove("menu-button_opened");
  unblockBody();
}

function isDesktop() {
  return document.body.offsetWidth >= 1024;
}

button.addEventListener("click", () => {
  opened ? closeMenu() : openMenu();
});

overlay.addEventListener("click", () => {
  closeMenu();
});

const menuItems = document.querySelectorAll(".menu__item");

menuItems.forEach((item) => {
  const dropdown = item.querySelector(".menu__button_dropdown");

  if (!dropdown) return;

  dropdown.addEventListener("click", (e) => {
    if (!isDesktop()) {
      e.preventDefault();

      item.classList.toggle("menu__item_opened");
    }
  });

  let isOpened = false;

  dropdown.addEventListener("mouseover", () => {
    if (isDesktop()) {
      item.classList.add("menu__item_opened");
      isOpened = true;
    }
  });

  item.addEventListener("mouseleave", () => {
    if (isDesktop() && isOpened) item.classList.remove("menu__item_opened");
  });
});

const submenuItems = document.querySelectorAll(".menu-submenu__item");

submenuItems.forEach((item) => {
  const button = item.querySelector(".menu-submenu__button");

  if (!button) return;

  button.addEventListener("click", () => {
    item.classList.toggle("menu-submenu__item_opened");
  });
});
